export const SET_CHALLENGES = "SET_CHALLENGES";
export const SET_ARCHIVED_CHALLENGES = "SET_ARCHIVED_CHALLENGES";
export const SET_CHALLENGES_BY_MEMBER_ID = "SET_CHALLENGES_BY_MEMBER_ID";
export const SET_MEMBER = "SET_MEMBER";
export const SET_MEMBER_BADGES = "SET_MEMBER_BADGES";
export const SET_MEMBER_BY_NAME = "SET_MEMBER_BY_NAME";
export const SET_MEMBER_TEAMS = "SET_MEMBER_TEAMS";
export const SET_MEMBER_TEAMS_ADMIN = "SET_MEMBER_TEAMS_ADMIN";
export const UPDATE_MEMBER_TEAM = "UPDATE_MEMBER_TEAM";
export const UPDATE_TEAMS_MEMBER_IS_ADMIN = "UPDATE_TEAMS_MEMBER_IS_ADMIN";
export const SET_MEMBER_TEAM_INVITES = "SET_MEMBER_TEAM_INVITES";
export const SET_TEAMS_BY_MEMBER_ID = "SET_TEAMS_BY_MEMBER_ID";
export const SET_LOADED_BADGES = "SET_LOADED_BADGES";
export const SET_LOADED_STATUS = "SET_LOADED_STATUS";
export const SET_LOADING_STATUS = "SET_LOADING_STATUS";
export const ADD_CHALLENGE = "ADD_CHALLENGE";
export const ADD_TEAM = "ADD_TEAM";
export const SET_CHALLENGE_INVITES = "SET_CHALLENGE_INVITES";
export const SET_MESSAGES = "SET_MESSAGES";
export const SET_MESSAGE_COUNT = "SET_MESSAGE_COUNT";
export const SET_JOIN_REQUEST_MESSAGES = "SET_JOIN_REQUEST_MESSAGES";
export const SET_MEMBER_FRIENDS = "SET_MEMBER_FRIENDS";
export const SET_FRIENDS_REQUESTING = "SET_FRIENDS_REQUESTING";
export const SET_FRIENDS_INVITED = "SET_FRIENDS_INVITED";
export const SET_STEP_DATA = "SET_STEP_DATA";
export const SET_METRIC_DATA = "SET_METRIC_DATA";
export const SET_WELLNESS_CHART_DATA = "SET_WELLNESS_CHART_DATA";
export const SET_STEP_DATA_BY_MEMBER_ID = "SET_STEP_DATA_BY_MEMBER_ID";
export const SET_METRIC_DATA_BY_MEMBER_ID = "SET_METRIC_DATA_BY_MEMBER_ID";
export const IS_JOURNAL_LAST_PAGE = "IS_JOURNAL_LAST_PAGE";
export const RESET_JOURNALS = "RESET_JOURNALS";
export const RESET_JOURNALS_BY_MEMBER_ID = "RESET_JOURNALS_BY_MEMBER_ID";
export const SET_JOURNALS = "SET_JOURNALS";
export const SET_JOURNAL_ENTRY_STATS = "SET_JOURNAL_ENTRY_STATS";
export const SET_MAKE_AN_ENTRY_JOURNAL = "SET_MAKE_AN_ENTRY_JOURNAL";
export const SET_JOURNAL_PAGE_JOURNAL = "SET_JOURNAL_PAGE_JOURNAL";
export const SET_JOURNALS_BY_MEMBER_ID = "SET_JOURNALS_BY_MEMBER_ID";
export const SET_ACTIVITIES = "SET_ACTIVITIES";
export const UPDATE_MEMBER_VALUE = "UPDATE_MEMBER_VALUE";
export const UPDATE_MEMBER_COPY_VALUE = "UPDATE_MEMBER_COPY_VALUE";
export const SET_MILESTONES = "SET_MILESTONES";
export const SET_LEADERBOARD_BY_MEMBER_ID = "SET_LEADERBOARD_BY_MEMBER_ID";
export const SET_MEMBER_NOTICE = "SET_MEMBER_NOTICE";
export const SET_DEVICE_API = "SET_DEVICE_API";
export const SET_MEMBER_ORGANIZATION_NOTICE = "SET_MEMBER_ORGANIZATION_NOTICE";
export const SET_MOBILE_CHALLENGES = "SET_MOBILE_CHALLENGES";
export const SET_MEMBER_FRIENDS_BY_MEMBER_ID =
  "SET_MEMBER_FRIENDS_BY_MEMBER_ID";
export const SET_MEMBER_FRIENDS_LOADED_STATUS =
  "SET_MEMBER_FRIENDS_LOADED_STATUS";
